import React from "react";
import { transformToHtml } from "../../../utils/CommonUtils";

export const FIS_HUB_URL = "https://www.makemytrip.com/flight/fis";

/** PWA toolbar background for route / airport FIS pages */
export const FIS_LISTING_TOOLBAR_BG_GRADIENT =
  "linear-gradient(to top, #15457b, #051423)";

/**
 * Toolbar header matching airline FIS detail (back + title on colored bar).
 * Used on route and airport listing pages; back navigates to FIS hub by default.
 */
export default function FisToolbarHeader({
  title,
  onBackClick,
}) {
  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
      return;
    }
    if (typeof window !== "undefined") {
      window.location.href = FIS_HUB_URL;
    }
  };

  return (
    <div className="flightStatusHeader fis-toolbar-header">
      <button
        type="button"
        className="headerBackButton"
        onClick={handleBackClick}
        aria-label="Back to Flight Status">
        <span className="headerBackIcon headerBackIcon--default" aria-hidden="true" />
      </button>
      <div className="headerContent">
        {title ? (
          <h1 className="headerTitle fontSize16 latoBlack">
            {transformToHtml(title)}
          </h1>
        ) : null}
      </div>
    </div>
  );
}

export function getFisListingToolbarStyle() {
  return { backgroundImage: FIS_LISTING_TOOLBAR_BG_GRADIENT };
}
